import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { Subject } from "rxjs";
import { AddinTabs, EvaluationFlowsEnum, OverviewSectionLink } from "../models/shared.model";

@Injectable({
  providedIn: 'root',
})

export class ScrollToSectionService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }


  private scrollToSectionSubject = new Subject<OverviewSectionLink>();

  scrollToSection(sectionObj: OverviewSectionLink) {
    this.scrollToSectionSubject.next(sectionObj);
  }

  get scrollToSection$() {
    return this.scrollToSectionSubject.asObservable();
  }

  fromEvaluationFlowToTab(flow: string){
      switch (flow) {
        case EvaluationFlowsEnum.SENDER:
          return AddinTabs.SENDER
        case EvaluationFlowsEnum.IMPERSONATION_RISK:
          return AddinTabs.SENDER
        case EvaluationFlowsEnum.LINKS:
          return AddinTabs.LINKS
        case EvaluationFlowsEnum.ATTACHMENTS:
          return AddinTabs.ATTACHMENTS
        case EvaluationFlowsEnum.QRCODE:
          return AddinTabs.LINKS
        default:
          return AddinTabs.OVERVIEW
      }
  }

  public applyHighlight(element: HTMLElement) {
    this.renderer.addClass(element, "highlight");
    setTimeout(() => {
      this.renderer.removeClass(element, "highlight");
    }, 2000);
  }
}
